export const actionColor: Record<string, string> = {
  assigned: "green",
  reassigned: "blue",
  unassigned: "red",
  additional_charge: "gold",
  charge_removed: "default",
};

export const fmt = (v: number) =>
  (Number(v) || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });
